"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultErrorMessageTitle = exports.ErrorMessage = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const defaultErrorMessageTitle = exports.defaultErrorMessageTitle = 'Error';
const ErrorMessage = ({
  children,
  title = defaultErrorMessageTitle
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Alert, {
  severity: "error",
  variant: "outlined",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.AlertTitle, {
    children: title
  }), children]
});
exports.ErrorMessage = ErrorMessage;
//# sourceMappingURL=ErrorMessage.js.map